<template>
  <v-text-field
    v-model="model"
    :placeholder="formLabel"
    solo
    type="text"
    rounded
    outlined
    dense
  />
</template>

<script>
import { nameRules } from '@/lib/rules.js';

export default {
  props: {
    fieldClass: {
      type: String,
      required: false,
      default: '',
    },
    currentLastPosition: {
      type: String,
    },
  },

  data() {
    return {
      lastPosition: '',
      nameRules,
      formLabel: 'תפקיד אחרון (לא חובה)',
    };
  },

  computed: {
    model: {
      get() {
        return this.currentLastPosition;
      },
      set(val) {
        // this.$emit('updatePosition', val);
        this.$emit('input', val);
      },
    },

    // displayUsersLastPosition() {
    //   return this.currentLastPosition
    //     ? this.currentLastPosition
    //     : this.forLabel;
    // },

    // isComplete() {
    //   return this.model && this.model.length > 0;
    // },
  },

  mounted() {
    // this.model = this.currentLastPosition;
  },

  watch: {
    // model() {
    //   if (this.model) {
    //     this.lastPosition = this.model;
    //   }
    // },
    // lastPosition() {
    //   this.$emit('updatePosition', this.lastPosition);
    // },
  },
};
</script>

